import React from "react";
import PropTypes from "prop-types";

import { Button, ContextMenu, Icon } from "@weezevent/nacre";
import { MenuOrga } from "./menu-orga";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { MenuEventConfig } from "./menu-event-config";
import useRouterContext from "../../context/routerContext";
import {
	useCheckpointsCapacities,
	useEventConfigCapacities
} from "../../utils/rights";
import MainCtaCreateButton from "../event/mainCtaCreateButton";
import useEventList from "api/api-hooks/useEventList";
import Styles from "./menu-side-bar.module.css";

export default function MenuSideBar({ organization, event }) {
	let menus = null;
	let contextMenu = null;

	const { t } = useTranslation();
	const { path } = useRouterContext(); // event path
	const orgaPath = `/access/O${organization.id()}`;
	const history = useHistory();
	const { canRead, canManage } = useEventConfigCapacities(organization.id());
	const { canAdd } = useCheckpointsCapacities(organization.id());

	const { data } = useEventList({
		params: {
			with_config: false
		}
	});

	const createEventConfigButton = (
		<MainCtaCreateButton
			label={t("access.menus.header.createEvent")}
			onClick={() => history.push(`${orgaPath}/events/new`)}
			disabled={data?.length === 0}
		/>
	);

	// We have no organization, no need to show menu
	if (!organization) {
		return null;
	}

	if (!event) {
		contextMenu = (
			<ContextMenu
				catchphrase={
					<>
						<Icon name="institution" />
						{t("access.menus.header.catchphrase", {
							id: organization.id()
						})}
					</>
				}
				title={organization.name()}
			>
				{canRead || canManage ? (
					createEventConfigButton
				) : (
					<Button
						as={Link}
						to={
							canAdd
								? `${path}/checkpoints/new`
								: window.location.pathname
						}
						primary
						fluid
						onlyIconMobile={false}
						label={t("access.menus.header.cta")}
						align="left"
						icon={<Icon name="plus" />}
						disabled={!canAdd}
					/>
				)}
			</ContextMenu>
		);
		menus = (
			<MenuOrga
				organizationId={organization.id()}
				isLevelEvent={Boolean(event)}
			/>
		);
	} else {
		contextMenu = (
			<ContextMenu
				catchphrase={
					<span className="event-catchphrase">
						<Icon name="institution" />
						{t("access.menus.header.catchphrase", {
							id: organization.id()
						})}
					</span>
				}
				title={
					<>
						<div>{`E ${event?.id}`}</div>
						<div className={Styles["event-title"]}>
							{event?.name}
						</div>
					</>
				}
			>
				{createEventConfigButton}
			</ContextMenu>
		);
		menus = (
			<MenuEventConfig
				organizationId={organization.id()}
				eventId={event?.id}
			/>
		);
	}

	return (
		<React.Fragment>
			{contextMenu}
			{menus}
		</React.Fragment>
	);
}

MenuSideBar.defaultProps = {
	event: null
};

MenuSideBar.propTypes = {
	organization: PropTypes.object.isRequired,
	event: PropTypes.object
};
